import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "error"];
import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import { api } from '../utils/api';
import { sortThreadsByLatest } from '../utils/sortThreadsByLatest';
import { getIsPreview } from '../utils/isPreview';
export const GET_TICKET_THREADS_KEY = 'getTicketThreads';
export const FAKE_THREAD_ID = 101;
const getTicketThreads = async variables => {
  const {
    ticketId
  } = variables;
  const {
    isPreview
  } = getIsPreview();
  if (isPreview) {
    return {
      threads: [{
        threadId: FAKE_THREAD_ID,
        startedAt: 1704067200000,
        latestMessageTimestamp: 1704153600000,
        originalChannel: 'EMAIL'
      }]
    };
  }
  const response = await api(`/_hcms/customerportal/v1/threadview/relevant-threads/${ticketId}`);
  return response.json();
};
export const GET_TICKET_THREADS = registerQuery({
  fieldName: GET_TICKET_THREADS_KEY,
  args: ['ticketId'],
  fetcher: getTicketThreads
});
export const useTicketThreads = (ticketId, options) => {
  const _useQuery = useQuery(GET_TICKET_THREADS, {
      variables: {
        ticketId
      },
      skip: !ticketId,
      pollInterval: options !== null && options !== void 0 && options.shouldPoll ? 10000 : undefined,
      skipPollAttempt: () => document.visibilityState === 'hidden'
    }),
    {
      data,
      loading,
      error
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const threads = useMemo(() => {
    var _data$GET_TICKET_THRE;
    return (data === null || data === void 0 || (_data$GET_TICKET_THRE = data[GET_TICKET_THREADS_KEY]) === null || _data$GET_TICKET_THRE === void 0 ? void 0 : _data$GET_TICKET_THRE.threads) || [];
  }, [data]);
  const latestThread = useMemo(() => {
    if (threads.length === 0) {
      return null;
    }
    return sortThreadsByLatest(threads)[0];
  }, [threads]);
  return Object.assign({
    threads,
    latestThread,
    loading,
    error
  }, rest);
};